import { Component } from '@angular/core';

@Component({
  selector: 'app-csr-service',
  templateUrl: './csr-service.component.html',
  styleUrl: './csr-service.component.scss',
})
export class CsrServiceComponent {
  items = [
    {
      title: 'وصف ',
      content:
        '   ​تقديم تقرير الشركات السنوي عن أنشطة المسئولية المجتمعية/ التنمية المستدامة وفقاً لقرار الرئيس التنفيذي للهيئة رقم 403 لسنة 2024 تفعيلا لنص المادة (3) من اللائحة التنفيذية لقانون الاستثمار رقم (72 لسنة 2017) ',
      expanded: false,
    },
    {
      title: ' المتطلبات الأساسية ',
      content:
        ' ​أن تكون الشركات خاضعة للقوانين المعمول بها في الهيئة العامة للاستثمار والمناطق الحرة',
      expanded: false,
    },
    {
      title: ' المستندات المطلوبة ',
      content: ' ​اقرار صحة البيانات',
      expanded: false,
    },
    {
      title: '  الرسوم جنيه مصرى',
      content: ' ​مجانًا بدون رسوم',
      expanded: false,
    },
    {
      title: ' الإطار الزمني ',
      content: '​تقديم التقرير عن سنة ميلادية  بنهاية شهر يناير من كل عام ',
      expanded: false,
    },
    {
      title: ' قنوات الخدمة ',
      content:
        'البوابة الإلكترونية للمسئولية المجتمعية للشركات عبر الرابط التالي https://csr.gafi.gov.eg/ ',
      expanded: false,
    },
    {
      title: ' السياسات والإجراءات ',
      content: ` - قم بالتسجيل وإنشاء الحساب وابدأ التقديم على البوابة الإلكترونية https://csr.gafi.gov.eg/

- ثم قم بملء الاستمارة كاملة، وسوف نقوم بمراجعتها.

- في حال مواجهة أي مشكلة أثناء أداء الخدمة إلكترونياً يرجى التواصل على البريد الالكتروني الخاص بتقديم تقارير الشركات csr.report@gafi.gov.eg

`,
      expanded: false,
    },
    {
      title: ' تحميل المستندات المساعدة ',
      content: ' ',
      expanded: false,
    },
  ];
  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
